import { render, staticRenderFns } from "./LabeledData.vue?vue&type=template&id=d638a2ec&scoped=true&"
import script from "./LabeledData.vue?vue&type=script&lang=js&"
export * from "./LabeledData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d638a2ec",
  null
  
)

export default component.exports